import React from "react";
import {Paper, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useRouteMatch} from "react-router-dom";
import {orangeBackgroundColor} from "../../../constants";
import {VaultPlan} from "../../Plan/Configuration/VaultPlan/VaultPlan";
import {useForwardPlanStepKeyboardShortcuts} from "../forwardPlanStepKeyboardShortcuts";
import {useSelector} from "react-redux";
import DisabledOverlay from "../DisabledOverlay";

const TextGridItem = () => {
  return (
    <Grid size={12} key={'upper_text'}>
      <Typography component="p" variant="body2" align={'center'} style={{fontSize: 0.92 + 'rem'}}>
        Positionieren Sie die Elemente per Drag & Drop auf der Seitenwand. Die Aussparungen und C-Schienen können in
        die gewünschte Grösse gezogen werden. Mit einem Doppelklick entfernen Sie das Element.
      </Typography>
    </Grid>
  )
}

export const VaultStep = () => {
  const match = useRouteMatch();
  const wallIndex = (m => {
    switch (m) {
      case '/step/2a':
        return 0
      case '/step/2b':
        return 1
      case '/step/2c':
        return 2
      case '/step/2d':
        return 3
      default:
        return 0
    }
  })(match.path);
  const {childRef} = useForwardPlanStepKeyboardShortcuts();
  const plan = useSelector(state => state.plan);
  const readOnly = !plan.vault || plan.vault.isStockVault;

  return (
    <Paper square={true} sx={{
      position: 'relative',
      background: orangeBackgroundColor,
      padding: '1em 2em 2em 2em'
    }} elevation={10}>
      <Grid container spacing={1}>
        <TextGridItem/>
        <Grid size={12}>
          <VaultPlan
            childRef={childRef}
            wallIndex={wallIndex}
            isToolbarVisible={true}
          />
        </Grid>
      </Grid>
      {readOnly && <DisabledOverlay message={"Standard Kabelschächte können nicht konfiguriert werden!"} /> }
    </Paper>
  )
};
